import moment from 'moment';

/**
 * Převádí granularitu (1h, 30min, ...) na minuty
 * @param granularity granularita
 * @returns minuty
 * TODO: dodělat 1,5h
 */
export const convertGranularityToMinutes = (granularity: string): number => {
  if (granularity && granularity.includes('h')) return Number(granularity.split('h')[0]) * 60;
  if (granularity && granularity.includes('m')) return Number(granularity.split('m')[0]);
  return 0;
};

/**
 * Převádí časovou značku na minuty
 * @param timestamp časová značka
 * @returns minuty
 */
export const convertTimeStampToMinutes = (timestamp: string): number => {
  const splitted = timestamp.split(':');
  const hours: number = Number(splitted[0]) * 60;
  const minutes: number = Number(splitted[1]);
  return hours + minutes;
};

/**
 * Převádí millisekundy na HH:mm:ss
 * @returns time string
 */
export const convertMsToTimeFormat = (ms: number) => {
  // kdyz vic nez 1 den
  if (ms > 86399999) {
    return moment.utc(ms).add(-1, 'day').format(`D[${'d'}] HH:mm:ss.SSS`);
  } else {
    return moment.utc(ms).format('HH:mm:ss.SSS');
  }
};
